<div class="">
  <div mat-dialog-content>
    <h2 style="font-size: 18px; text-align: center">
      <b>Add New Folder</b>
    </h2>
    <form #userNewForm="ngForm">
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>Folder Name</mat-label>
          <input
            name="folder"
            type="text"
            [(ngModel)]="folder.name"
            matInput
            placeholder="Folder Name"
            required
          />
        </mat-form-field>
        <div *ngIf="!loading">
          <mat-form-field appearance="fill">
            <mat-label>Authorize Users</mat-label>
            <mat-select
              name="selectedUsers"
              [formControl]="users"
              [(ngModel)]="folder.permissions"
              multiple
              id="nameCliente"
              required
              [compareWith]="compareUsers"
            >
              <mat-select-trigger>
                <!-- {{ rep}} -->
                {{ users.value?.length > 0 ? pipeusers(users.value[0]) : "" }}
                <span
                  *ngIf="users.value?.length > 1"
                  class="example-additional-selection"
                >
                  (+{{ users.value.length - 1 }} {{ users.value?.length === 2 ?
                  "other" : "others" }})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let user of usertoAssign" [value]="user"
                >{{ user.name }} {{ user.surname }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <mat-progress-bar
          style="width: 100%"
          *ngIf="loading"
          id="loadingbar"
          mode="indeterminate"
        ></mat-progress-bar>

        <mat-form-field class="example-full-width">
          <mat-label>Authorize Group</mat-label>
          <input
            type="text"
            name="groupSelected"
            [(ngModel)]="folder.group_permissions"
            placeholder="Group Name"
            aria-label="Group Name"
            matInput
            [formControl]="myControl"
            [matAutocomplete]="autoClientes"
            id="clienteSP1"
            (focus)="onInputFocus()"
          />
          <mat-autocomplete
            (optionSelected)="onHumanSelected($event.option)"
            #autoClientes="matAutocomplete"
            [displayWith]="displayFn"
          >
            <mat-option
              *ngFor="let option of filteredGroups | async"
              [value]="option"
            >
              {{ option.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <!-- <label class="bmd-label-floating">Folder Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="company"
                    #company="ngModel"
                    [(ngModel)]="this.folder.name"
                    required
                  /> -->
      </div>
      <div>
        <div mat-dialog-actions>
          <button
            type="button"
            class="gts-btn-primary"
            [mat-dialog-close]="this.folder"
            cdkFocusInitial
            [disabled]="!userNewForm.valid || !folder.permissions"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- <div class="col-md-4">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Authorize User</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <div class="form-group" *ngIf="loading == false"> -->
  <!-- <mat-form-field class="example-full-width">
                  <mat-label>Authorized Users</mat-label>
                  <input
                    type="text"
                    [(ngModel)]="this.folder.user_id"
                    placeholder="Select"
                    aria-label="Select"
                    matInput
                    [formControl]="myControlClientes"
                    [matAutocomplete]="autoClientes"
                    id="nameCliente"
                  />
                  <mat-autocomplete
                    #autoClientes="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    <mat-option
                      *ngFor="let option of filteredClientes | async"
                      [value]="option"
                    >
                      {{option.name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field> -->
  <!-- <button
                  (click)="selectUserPermission()"
                  class="btn btn-success"
                  [disabled]="!folder.user_id"
                >
                  Add user
                </button> -->
  <!-- <div class="col-md-12">
                  Authorized Users:
                  <ul style="list-style: none" id="listausuarios">
                    <li
                      id="{{permission}}"
                      *ngFor="let permission of permissionsShow"
                    >
                      <i style="color: green" class="material-icons">person</i>
                      {{permission}}
                      <i
                        style="color: red"
                        (click)="deletePermiso(permission)"
                        class="material-icons"
                      >
                        delete_forever
                      </i>
                    </li>
                  </ul>
                </div> -->
  <!-- </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
